import React, { useCallback, useEffect } from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import useAxios from 'hooks/useAxios'
import { Loader } from 'shared/components/Loader'
import * as R from 'ramda'
import auth from 'auth'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import store from 'store'
import constants from 'config/constants'

export default function Workspace() {
  const { data, loading, error } = useAxios({
    url: 'account/workspaces/',
    skip: !auth.getToken(),
  })

  const location = useLocation()
  const url = `${location.pathname}${location.search}`

  const history = useHistory()

  const saveUserActivityLog = useSaveUserActivityLog()
  const shouldDoSignedInLogCallBack = checkSignedInLogCallBack(location)

  const workspaceToken = R.path(['results', 0, 'workspace_token'], data)
  const workspaces = R.defaultTo([], R.path(['results'], data))
  const availabledWorkspaceToken = workspaces.map((workspace) => workspace.workspace_token)

  const companyId = R.path(['results', 0, 'id'], data)
  const totalWorkspace = R.pathOr([], ['results'], data).length

  const callSaveUserActivityLog = useCallback(
    (companyId, workspaceToken) => {
      const userInfo = auth.getUserInfoFromToken()
      const loggedInMethod = getLoggedInMethod(location)
      saveUserActivityLog({
        action: ACTION_NAME.signed_in,
        target: `com_${companyId}`,
        statusCode: 200,
        requestBody: { ...userInfo, logged_in_method: loggedInMethod },
        headers: { 'X-Workspace-Token': workspaceToken },
      })
    },
    [location, saveUserActivityLog]
  )

  useEffect(() => {
    if (shouldDoSignedInLogCallBack && workspaceToken && companyId && totalWorkspace === 1) {
      callSaveUserActivityLog(companyId, workspaceToken)
    }
  }, [
    shouldDoSignedInLogCallBack,
    workspaceToken,
    companyId,
    callSaveUserActivityLog,
    totalWorkspace,
  ])

  if (!auth.getToken()) {
    return (
      <Redirect
        to={{
          pathname: '/login/',
          search: location.search,
          state: { prev: location }
        }}
      />
    )
  } else if (loading && !data) {
    return <Loader />
  } else if (data) {
    if (totalWorkspace === 1) {
      const redirectUrl = getRedirectUrl(url, workspaceToken)
      return <Redirect to={redirectUrl} />
    } else if (totalWorkspace > 1) {
      const localStorageWorkspaceToken = store.get(constants.simplesatWorkspaceTokenName)

      if (availabledWorkspaceToken.includes(localStorageWorkspaceToken)) {
        const redirectUrl = getRedirectUrl(url, localStorageWorkspaceToken)
        return <Redirect to={redirectUrl} />
      } else {
        const loggedInMethod = getLoggedInMethod(location)
        history.push({
          pathname: '/workspaces/',
          state: { previousUrl: url, loggedInMethod: loggedInMethod },
        })
        return null
      }
    } else {
      return <Redirect to="/workspaces/" />
    }
  } else if (error) {
    return <Redirect to="/workspaces/" />
  } else {
    return null
  }
}

function getRedirectUrl(url, workspaceToken) {
  if (url === '/') {
    return `/${workspaceToken}/`
  } else {
    return `/${workspaceToken}${url}`
  }
}

function checkSignedInLogCallBack(location) {
  return R.path(['state', 'saveUserActivityLog', 'action'], location) === 'signed_in'
}

function getLoggedInMethod(location) {
  return R.path(['state', 'saveUserActivityLog', 'requestBody', 'logged_in_method'], location)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Workspace/index.js